import { defineAsyncComponent } from "vue";
import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
import Layout from "@/views/layouts/index.vue";
import { UserStore, useUserStore } from "@/stores/user";

const statementStatisticsRouter: RouteRecordRaw[] = [
    {
        path: "/statementStatistics",
        name: "StatementStatistics",
        component: Layout,
        redirect: "/statementStatistics/project",
        meta: {
            title: "报表统计"
        },
        children: [
            {
                path: "/statementStatistics/project",
                name: "ProjectStatement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/statementStatistics/projectStatement/index.vue");
                    }
                }),
                meta: {
                    title: "项目报表",
                    isNotShowHeader: true
                }
            },
            {
                path: "/statementStatistics/fund",
                name: "FundStatement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/statementStatistics/fundStatement/index.vue");
                    }
                }),
                meta: {
                    title: "资金报表",
                    isNotShowHeader: true
                }
            },
            {
                path: "/statementStatistics/Logistics",
                name: "LogisticsStatement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/statementStatistics/logisticsStatement/index.vue");
                    }
                }),
                meta: {
                    title: "物流报表",
                    isNotShowHeader: true
                }
            },
            {
                path: "/statementStatistics/risk",
                name: "RiskStatement",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/statementStatistics/riskStatement/index.vue");
                    }
                }),
                meta: {
                    title: "风控报表",
                    isNotShowHeader: true
                }
            },
            {
                path: "/statementStatistics/financing",
                name: "FinancingStatement",
                component: () => import("@/components/emptyPage/index.vue"),
                meta: {
                    title: "客户报表",
                    hidden: ({ userStore }: { userStore: UserStore }) => {
                        return !userStore.isSAAS;
                    },
                    isNotShowHeader: true
                }
            },
            {
                path: "/statementStatistics/financing",
                name: "FinancingStatement",
                component: () => import("@/views/pages/statementStatistics/financingStatement/index.vue"),
                meta: {
                    hidden: ({ userStore }: { userStore: UserStore }) => {
                        return userStore.isSAAS;
                    },
                    title: "融资报表",
                    isNotShowHeader: true
                }
            },
            {
                path: "/statementStatistics/stock",
                name: "StockStatement",
                meta: {
                    title: "库存报表"
                },
                redirect: "/statementStatistics/stock/reportPackage",
                children: [
                    {
                        path: "inboundDetection",
                        name: "InboundDetection",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/inboundDetection/index.vue"),
                        meta: {
                            title: "入库检测表",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code
                        }
                    },
                    {
                        path: "detailed",
                        name: "StockDetailed",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/detailed/index.vue"),
                        meta: {
                            title: "库存明细",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code
                        }
                    },
                    {
                        path: "summary",
                        name: "StockSummary",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/summary/index.vue"),
                        meta: {
                            title: "库存汇总",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code
                        }
                    },
                    {
                        path: "reportPackage",
                        name: "StockReportPackage",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/reportPackage/index.vue"),
                        meta: {
                            title: "报表打包",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code
                        }
                    },
                    {
                        path: "coreLibrary",
                        name: "StockCoreLibrary",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/coreLibrary/index.vue"),
                        meta: {
                            title: "核库报表",
                            isNotShowHeader: true,
                            pageType: PAGE_TYPE.LIST.code
                        }
                    },
                    {
                        path: "coreLibrary/detail/:id",
                        name: "StockCoreLibraryDetail",
                        component: () => import("@/views/pages/statementStatistics/stockStatement/coreLibrary/detail.vue"),
                        meta: {
                            title: "核库报表明细",
                            isNotShowHeader: true,
                            activeMenu: "StockCoreLibrary",
                            hidden: true
                        }
                    }
                ]
            }
        ]
    }
];

export default statementStatisticsRouter;
